let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cK8VY")).then(() => parcelRequire('4VIPx'));